import { render, staticRenderFns } from "./DialogAcaoExternaFornecedor.vue?vue&type=template&id=346a26dd"
import script from "./DialogAcaoExternaFornecedor.vue?vue&type=script&lang=js"
export * from "./DialogAcaoExternaFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports